/**
 * Development / QA environment configuration.
 * Substituted for environment.ts by the `fileReplacements` entry in angular.json
 * during development builds (`ng build -c=dev`, `ng build -c=development`, or `npm run deploy:dev`).
 */
export const environment = {
  production: false,
  googleClientId: '300443444189-8v7fu0hkkcq0ilndl5pooeqea7lm1u8j.apps.googleusercontent.com',
  apiBaseUrl: 'https://corp-gars-gateway-3u0s9p7h.ew.gateway.dev',
  apiUrl: 'https://corp-gars-gateway-3u0s9p7h.ew.gateway.dev/api/',
  directApiUrl: 'https://gemini-report-300443444189.europe-west1.run.app/api/',
  version: 'v1'
};
